// extracted by mini-css-extract-plugin
export default {"container":"WriteButton_container__DrVPE","addbutton":"WriteButton_addbutton__6IwdI"};